<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">应用续费</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-loading="loading" class="modal-body">
          <form>
            <div class="form-group">
              <label for="formGroupExampleInput">选择续费时间</label>
            </div>
            <div v-for="(mealInfo,index) in mealInfos">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                    :value="mealInfo.effectiveDays" checked @click="selectDay(mealInfo.effectiveDays)">
                  {{mealInfo.effectiveDays}}天&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>{{mealInfo.mealPrice}}元</span>
                </label>
              </div>
              <br>
            </div>
            <br>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">支付方式</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="payWay" value="1" disabled>
              <label class="form-check-label" for="inlineRadio1">微信</label>
            </div>
            <div class="form-check form-check-inline" style="margin-left: 1em;">
              <input class="form-check-input" type="radio" name="payWay" value="2" checked>
              <label class="form-check-label" for="inlineRadio2">支付宝</label>
            </div>
          </form>
          <br>
          <div id="pay_qrcode">
            <img v-if="payWay=='1'" style="height: 2em;" src="/static/img/WePayLogo.png">
            <img v-else style="width:10em" src="../assets/img/logo_alipay.jpg">
            <p></p>
            <div>
              <div id="qrcode" style="display: none"></div>
              <span class="qrcode" title>
                <img style="height:10em" alt="Scan me!" src>
              </span>
            </div>
            <br>
            <p style="color:#F76C24">支付成功后，刷新签名管理页面核查 如有疑问联系客服：2449450354</p>
          </div>
        </div>
        <div class="modal-footer">
          <button style="width: 30em;height: 3em;" type="button" class="btn btn-primary" @click="pay"
            :disabled="pay_button_disabled">马上支付</button>
        </div>
      </div>
    </div>
    <WebSocket v-on:webSocketHandle="webSocketHandle" />
  </div>
</template>
<script>
var self;
import "assets/js/jquery.qrcode.min";
import "assets/js/jquery.rotate.min";
import WebSocket from "./WebSocket";
export default {
  props: ["autoSignAppId", "mealId"],
  components: {
    WebSocket
  },
  data() {
    return {
      isPay: false,
      day: 0,
      payLink: "",
      pay_button_disabled: false,
      thirty_price: 0,
      ninety_price: 0,
      one_year_price: 0,
      money: null,
      mealInfos: [],
      loading: true
    };
  },
  mounted() {
    self = this;
    $("#pay_qrcode").hide();
    this.getMealInfos();
    // console.log(this.autoSignAppId);
    console.log("tag", self.day_price_mapper);
    $("#app_info_modal").modal("show");
    $("#app_info_modal").on("hidden.bs.modal", function(e) {
      console.log("模态框消失");
      self.$emit("showAutoSignDelayModal", false);
    });
  },
  methods: {
    selectDay: function(day) {
      this.day = day;
    },
    getMealInfos: function() {
      this.$http
        .post(this._Global.HTTP_SERVER + "/meal/list_mealId", {
          mealId: this.mealId
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            self.mealInfos = data;
            self.loading = false;
            self.day = data[data.length - 1].effectiveDays;
            console.log("tag", self.day);
          });
        });
    },
    pay: function(params) {
      var payWay = $("input:radio[name='payWay']:checked").val();
      var params = {
        autoSignAppId: this.autoSignAppId,
        authToken: this.getToken(),
        day: this.day,
        payWay: payWay
      };
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/pay/auto/sign/delay", params)
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            $("#pay_qrcode").show();
            self.pay_button_disabled = true;
            var qrcode = jQuery("#qrcode").qrcode(data.code_url);
            var canvas = qrcode.find("canvas").get(0);
            $(".qrcode img").attr("src", canvas.toDataURL("image/jpg"));
          });
        });
    },
    webSocketHandle: function(data) {
      window.layer.msg("支付成功,页面正在跳转...");
      setTimeout(function() {
        $("#app_info_modal").modal("hide");
        window.location.reload();
      }, 2000);
    }
  }
};
</script>
<style scoped>
form {
  text-align: left;
}
.modal-body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoSignDelayWindow.vue